import { Typography } from '@/components/ui/atoms/Typography';

interface CandidateIdentityProps {
  name: string;
  email?: string | null;
}

/** Candidate name (emphasized) over email (muted), shared by the stage-change dialogs. */
export function CandidateIdentity({ name, email }: CandidateIdentityProps) {
  return (
    <div>
      <Typography variant="body-sm" color="primary" weight="semibold" as="p" className="break-all">
        {name}
      </Typography>
      {email ? (
        <Typography variant="body-xs" color="secondary" as="p" className="break-all">
          {email}
        </Typography>
      ) : null}
    </div>
  );
}
